module.exports = __webpack_public_path__ + "assets/img/pdf.05b74434.svg";